<svg width="1em" class="loading-spinner" viewBox="0 0 90 90" aria-hidden="true" focusable="false">
    <circle cx="25" cy="25" r="15"/>
    <circle cx="65" cy="25" r="15"/>
    <circle cx="65" cy="65" r="15"/>
    <circle cx="25" cy="65" r="15"/>
</svg>
